// @flow

import React from 'react';
import './bell.css';

const Bell = ({shake} : {shake: boolean})  => (
    <div className="bell-container">
        <div className="background-bell">
            <div className={`ico-bell ${shake ? 'shake' : ''}`} />
        </div>
    </div>
)

export default Bell;



// WEBPACK FOOTER //
// ./src/components/common/reminder/bell.js